import { render } from "./textAreaVee4.vue?vue&type=template&id=6e43284b"
import script from "./textAreaVee4.vue?vue&type=script&lang=js"
export * from "./textAreaVee4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__